import { render, staticRenderFns } from "./SelectIncidence.vue?vue&type=template&id=4c4435f6&"
import script from "./SelectIncidence.vue?vue&type=script&lang=js&"
export * from "./SelectIncidence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports